import { render, staticRenderFns } from "./DefaultTooltip.vue?vue&type=template&id=5d55204d&scoped=true"
import script from "./DefaultTooltip.vue?vue&type=script&lang=js"
export * from "./DefaultTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d55204d",
  null
  
)

export default component.exports